import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M8.29 20.002c7.547 0 11.675-6.156 11.675-11.494 0-.176 0-.35-.012-.523A8.265 8.265 0 0022 5.894a8.273 8.273 0 01-2.356.636 4.07 4.07 0 001.804-2.235 8.303 8.303 0 01-2.606.98 4.153 4.153 0 00-5.806-.175 4.006 4.006 0 00-1.187 3.86 11.717 11.717 0 01-8.457-4.22 4.005 4.005 0 001.271 5.392A4.122 4.122 0 012.8 9.627v.051c.001 1.923 1.378 3.579 3.292 3.96a4.144 4.144 0 01-1.852.069c.537 1.646 2.078 2.773 3.833 2.806A8.315 8.315 0 012 18.188a11.754 11.754 0 006.29 1.811"
            />
        </svg>
    );
};

export default React.memo(Twitter);
